import { SalesforceActionCreatorFactoryBase } from './salesforce.actionCreator.factory-base';
import { ContactActionCreator } from '../actionFacade/actionCreators/contact/contact.actioncreator';
import { SalesforceClassicContactActionCreator } from './contacts/salesforceClassic.contact.actionCreator';

export default class SalesforceClassicActionCreatorFactory extends SalesforceActionCreatorFactoryBase {
  public createContactActionCreator(): ContactActionCreator {
    return new SalesforceClassicContactActionCreator(this.store, this.salesforceLightningProxy);
  }
}
